module.exports = __webpack_public_path__ + "static/media/alerta-infracciones-rojo.00e762bd.svg";